<footer class="footer widget-footer clearfix" id="contact">
  <div class="first-footer ttm-bgcolor-skincolor ttm-bg ttm-bgimage-yes bg-img1">
    <div class="ttm-row-wrapper-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row align-items-md-center">
        <div class="col-lg-4 col-md-4 col-sm-6 order-md-1 d-none">
          <div class="text-left">
            <!-- featured-icon-box -->
            <div class="featured-icon-box left-icon icon-align-top">
              <div class="featured-icon d-none">
                <div class="ttm-icon ttm-icon_element-color-white ttm-icon_element-size-md">
                  <i class="ti ti-location-pin"></i>
                </div>
              </div>
              <div class="featured-content"></div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center">
          <a class="ttm-btn ttm-btn-size-md ttm-btn-style-border ttm-icon-btn-left ttm-btn-color-white" href="mailto:sales@qualibar.com" title="">
            sales&#64;qualibar.com <i class="fa fa-envelope-o"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="second-footer ttm-textcolor-white bg-img2">
    <div class="container">
      <div class="row locations-container">
        <div class="widget-area col-md-5 ">
          <h3 class="widget-title">USA </h3>
          <div class="row">
            <div class="col-md-6 atlanta-ofc">
              <div class="widget widget_text  clearfix  ">
                <h3 class="widget-title">Greater Atlanta </h3>
                <div class="textwidget widget-text" style="min-height: 80px;">
                  11285 Elkins Road, Suite D4<br>
                  Roswell, GA 30076
                </div>
                <div class="quicklink-box d-none">
                  <div class="featured-icon-box left-icon">
                    <div class="featured-icon">
                      <div class="ttm-icon ttm-icon_element-style-round ttm-icon_element-bgcolor-skincolor ttm-icon_element-size-md ttm-icon_element-style-round">
                        <span class="flaticon flaticon-clock"></span>
                      </div>
                    </div>
                    <div class="featured-content">
                      <div class="featured-desc"></div>
                      <div class="featured-title">
                        <h5>+1 404.863.4994</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="widget widget_text  clearfix  ">
                <h3 class="widget-title">New York City </h3>
                <div class="textwidget widget-text" style="min-height: 80px;">
                  155 Water St P4/6A<br>
                  Brooklyn, NY 11201
                </div>
                <div class="quicklink-box d-none">
                  <div class="featured-icon-box left-icon">
                    <div class="featured-icon">
                      <div class="ttm-icon ttm-icon_element-style-round ttm-icon_element-bgcolor-skincolor ttm-icon_element-size-md ttm-icon_element-style-round">
                        <span class="flaticon flaticon-clock"></span>
                      </div>
                    </div>
                    <div class="featured-content">
                      <div class="featured-desc"></div>
                      <div class="featured-title">
                        <h5>+1 404.863.4994</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-area col-md-5 ">
          <h3 class="widget-title">India </h3>
          <div class="row">
            <div class="col-md-6 banglore-ofc">
              <div class="widget widget_text  clearfix  ">
                <h3 class="widget-title">Bangalore </h3>
                <div class="textwidget widget-text" style="min-height: 70px;">
                  Vaishnavi Signature 78/9<br>
                  Bangalore 560103
                </div>
                <h6 class="mt-2 mb-0">
                  Phone : <a href="tel:+91 973 939 4994">+91 973 939 4994</a>
                </h6>
                <div class="quicklink-box d-none">
                  <div class="featured-icon-box left-icon">
                    <div class="featured-icon">
                      <div class="ttm-icon ttm-icon_element-style-round ttm-icon_element-bgcolor-skincolor ttm-icon_element-size-md ttm-icon_element-style-round">
                        <span class="flaticon flaticon-clock"></span>
                      </div>
                    </div>
                    <div class="featured-content">
                      <div class="featured-desc"></div>
                      <div class="featured-title">
                        <h5>+91 973 939 4994</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 ">
              <div class="widget widget_text  clearfix  ">
                <h3 class="widget-title">Bhubaneswar</h3>
                <div class="textwidget widget-text" style="min-height: 70px;">
                  Esplanade One, Suite 309<br />
                  Bhubaneswar, Odisha 751010
                </div>
                <h6 class="mt-2 mb-0">
                  Phone : <a href="tel:+91 973 939 4994">+91 973 939 4994</a>
                </h6>
                <div class="quicklink-box d-none">
                  <div class="featured-icon-box left-icon">
                    <div class="featured-icon">
                      <div class="ttm-icon ttm-icon_element-style-round ttm-icon_element-bgcolor-skincolor ttm-icon_element-size-md ttm-icon_element-style-round">
                        <span class="flaticon flaticon-clock"></span>
                      </div>
                    </div>
                    <div class="featured-content">
                      <div class="featured-desc"></div>
                      <div class="featured-title">
                        <h5>Phone : +91 973 939 4994</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class=" widget-area col-md-2 ">
          <div class="widget flicker_widget clearfix text-center">
            <h3 class="widget-title text-left">Follow Us On</h3>
            <div class="textwidget widget-text">
              <div class="social-icons circle social-hover">
                <ul class="list-inline">
                  <li class="social-linkedin">
                    <a class=" tooltip-top" target="_blank" href="https://www.linkedin.com/company/qualibar/" data-tooltip="LinkedIn">
                      <i class="fa fa-linkedin" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li class="social-facebook">
                    <a class="tooltip-top" target="_blank" href="https://www.facebook.com/qualibar/" data-tooltip="Facebook">
                      <i class="fa fa-facebook" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li class="social-twitter">
                    <a class="tooltip-top" target="_blank" href="https://twitter.com/QualibarInc" data-tooltip="Twitter">
                      <i class="fa fa-twitter" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li class="social-flickr">
                    <a class=" tooltip-top" target="_blank" href="https://www.instagram.com/qualibarinc/" data-tooltip="Instagram">
                      <i class="fa fa-instagram" aria-hidden="true"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-footer-text ttm-bgcolor-darkgrey ttm-textcolor-white">
    <div class="container">
      <div class="row copyright">
        <div class="col-md-12 text-center">
          <div class="">
            <span> <a href="#">&copy; 2025 Qualibar Inc. USA | Qualibar Pvt. Ltd. India</a></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

